import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  const { settings } = useSettings();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-[#0A1626] text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <Logo className="h-12 w-12" settings={settings} />
            <span className="font-heading text-lg font-extrabold uppercase text-white">BJRC</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            {settings?.footer_text || "Brackenfell Junior Rugby Club — developing young rugby players in Brackenfell, Cape Town."}
          </p>
          <div className="mt-4 flex gap-3">
            {settings?.facebook && (
              <a href={settings.facebook} target="_blank" rel="noreferrer" className="rounded-full bg-white/10 p-2 hover:bg-[#1E63D6]" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
            )}
            {settings?.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer" className="rounded-full bg-white/10 p-2 hover:bg-[#1E63D6]" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
            )}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-[#E8A317]">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {[["About BJRC", "/about"], ["Age Groups", "/age-groups"], ["Our Coaches", "/coaches"], ["Gallery", "/gallery"], ["News & Events", "/news"]].map(([l, to]) => (
              <li key={to}><Link to={to} className="hover:text-white">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-[#E8A317]">Get Involved</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {[["Join BJRC", "/join"], ["Sponsors", "/sponsors"], ["Contact Us", "/contact"], ["Privacy Policy", "/privacy"], ["Website Terms", "/terms"]].map(([l, to]) => (
              <li key={to}><Link to={to} className="hover:text-white">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-[#E8A317]">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            {settings?.address && (
              <li className="flex min-w-0 gap-2"><MapPin className="h-4 w-4 shrink-0 text-[#1E63D6]" /><span className="break-words">{settings.address}</span></li>
            )}
            {settings?.phone_admin && (
              <li className="flex min-w-0 gap-2"><Phone className="h-4 w-4 shrink-0 text-[#1E63D6]" /><a href={`tel:${settings.phone_admin.replace(/\s/g, "")}`} className="break-all hover:text-white">{settings.phone_admin}</a></li>
            )}
            {settings?.email_admin && (
              <li className="flex min-w-0 gap-2"><Mail className="h-4 w-4 shrink-0 text-[#1E63D6]" /><a href={`mailto:${settings.email_admin}`} className="break-all hover:text-white">{settings.email_admin}</a></li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
        © {year} {settings?.club_name || "Brackenfell Junior Rugby Club"}. All rights reserved. ·{" "}
        <Link to="/admin" className="hover:text-slate-300">Admin</Link>
      </div>
    </footer>
  );
};
